import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { SadieStatDelta } from "@/components/tools/sadie-dashboard/SadieStatDelta";
import { Card } from "@ui/card";

import { sadieDashboard } from "@/lib/sadieDashboard";
import {
  SadieDashboardRange,
  SadieDashboardStat,
  SadieStatFormat,
} from "@/types";

// Laborup jobs Sadie applied workers to after they said yes to her pitch.
export const SadieInternalApplicationsCard = ({
  internalApplications,
  range,
}: {
  internalApplications: SadieDashboardStat;
  range: SadieDashboardRange;
}) => (
  <Card className="p-5">
    <Column className="gap-3">
      <Column className="gap-0.5">
        <Text className="font-plex-mono text-[9px] font-medium uppercase tracking-wider text-slate-500">
          Applications
        </Text>
        <Text className="text-sm font-semibold text-slate-900">
          Internal applications
        </Text>
      </Column>
      <Text className="text-3xl font-semibold text-slate-900">
        {sadieDashboard.formatValue(
          internalApplications,
          SadieStatFormat.COUNT,
        )}
      </Text>
      <SadieStatDelta
        format={SadieStatFormat.COUNT}
        range={range}
        stat={internalApplications}
      />
      <Text className="text-xs font-normal text-slate-500">
        Applications to Laborup jobs Sadie pitched, after the worker said yes
      </Text>
    </Column>
  </Card>
);
